import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { EquipSection } from '../organisms';
import { routes } from '@lean-body/src/route';
import { LessonPlaylistBox, SHADOW_WIDTH } from './lesson_playlist_box';
import { LessonMetaTrainers } from '../atoms/lesson_meta_trainers';
import { LessonMetaUserAction } from './lesson_meta_user_action';
import { LessonMetaTitleWithInfo } from '../atoms/lesson_meta_title_with_info';
import { useRefHooks } from '@lean-body/src/util';
import { PlaylistMetaAboveLessonName } from '../atoms/playlist_meta_above_lesson_name';
import { TvBanner } from '../organisms/tv_banner';
export const LessonMeta = ({ lesson, currentLessonIndex, program, playlist, nextLesson, programLessons, isFavorite, onClickFavLesson, onClickTwitterShareIfAuthed, addFavoriteLesson, unFavoriteLesson, twitterService, onClickLesson, displayLessonPlaylistBox, config, }) => {
    const [isShowOtherLessons, setIsShowOtherLessons] = React.useState(false);
    const { ref, element } = useRefHooks();
    const onClickShowOtherLessonsIcon = () => {
        element.scrollTo(0, 0); // container がスクロールされた状態で LessonPlaylistBox を開くと位置がバグるので、上に移動
        setIsShowOtherLessons(!isShowOtherLessons);
    };
    return (React.createElement("div", { className: css(styles.container, displayLessonPlaylistBox ? styles.containerWithPlaylistBox : styles.containerWithoutPlaylistBox, isShowOtherLessons && styles.showOtherLessons), ref: ref },
        React.createElement("div", { className: css(styles.info, styles.section) },
            React.createElement(LessonMetaTitleWithInfo, { link: routes.PROGRAM.compile({ slug: program.slug }), linkText: program.name, title: lesson.name, favoriteCount: lesson.lessonAggregate.totalFavoriteCount, difficulty: lesson.difficulty, minCal: lesson.minCal, maxCal: lesson.maxCal, pace: lesson.pace, tags: lesson.tags, style: lesson.style }),
            React.createElement(LessonMetaUserAction, { classObject: styles.userActionRow, lesson: lesson, isFavorite: isFavorite, onClickFav: onClickFavLesson, twitterService: twitterService, onClickTwitterShareIfAuthed: onClickTwitterShareIfAuthed })),
        React.createElement(LessonMetaTrainers, { classObject: styles.section, trainers: lesson.trainers }),
        React.createElement("div", { className: css(styles.descriptionSection, styles.section) },
            React.createElement("div", { className: css(styles.description) }, lesson.description)),
        React.createElement(EquipSection, { classObject: styles.equips, title: "\u4F7F\u7528\u3059\u308B\u30A2\u30A4\u30C6\u30E0", equips: lesson.equipments, noUnderline: true }),
        React.createElement(TvBanner, { classObject: styles.tvAnnouncement, config: config, text: "\u30C6\u30EC\u30D3\u306E\u5927\u753B\u9762\u3067\u30EC\u30C3\u30B9\u30F3\u3092\u697D\u3057\u307F\u307E\u3057\u3087\u3046\uFF01" }),
        displayLessonPlaylistBox && (React.createElement(LessonPlaylistBox, { program: program, playlist: playlist, currentLessonIndex: currentLessonIndex, nextLesson: nextLesson, programLessons: programLessons, addFavoriteLesson: addFavoriteLesson, unFavoriteLesson: unFavoriteLesson, isShowOtherLessons: isShowOtherLessons, onClickLesson: onClickLesson, onClickShowOtherLessonsIcon: onClickShowOtherLessonsIcon, showTopImg: true, aboveLessonName: (index) => !!playlist &&
                playlist.isChallenge && (React.createElement(PlaylistMetaAboveLessonName, { classObject: styles.aboveLessonName, index: index + 1, isNext: playlist.isChallenging && index === playlist.currentOrderIndex, isDone: playlist.isChallenging && programLessons[index].isCompleted })) }))));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        background: Colors.White,
        flex: 1,
    },
    containerWithPlaylistBox: {
        padding: '14px 16px 180px',
        [MediaBreakPointUp.MD]: {
            padding: `14px ${SHADOW_WIDTH}px 100px`,
        },
        [MediaBreakPointUp.XL]: {
            padding: '14px 0 0',
        },
    },
    containerWithoutPlaylistBox: {
        padding: '14px 16px 24px',
        [MediaBreakPointUp.MD]: {
            padding: `14px ${SHADOW_WIDTH}px 24px`,
        },
        [MediaBreakPointUp.XL]: {
            padding: '14px 0 0',
        },
    },
    showOtherLessons: {
        overflow: 'hidden',
    },
    info: {
        paddingBottom: 14,
    },
    userActionRow: {
        marginTop: 8,
    },
    section: {
        borderBottom: `1px solid ${Colors.BorderLightGray}`,
    },
    descriptionSection: {
        paddingTop: 10,
        paddingBottom: 10,
    },
    description: {
        fontSize: 12,
        fontWeight: 400,
        lineHeight: '18px',
        display: 'flex',
        alignItems: 'flex-start',
        whiteSpace: 'pre-wrap',
    },
    equips: {
        marginBottom: 0,
    },
    aboveLessonName: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 2,
    },
    tvAnnouncement: {
        marginTop: 20,
    },
});
